import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { secureStorageAdapter } from '../main/utils/storageHelper';

type SyncState = {
  syncCode: string | null;
  writeKey: string | null;
  statSyncPurchased: boolean;
  setSyncCode: (code: string) => void;
  setWriteKey: (key: string) => void;
  setStatSyncPurchased: () => void;
  clearSync: () => void;
};

export const useSyncStore = create<SyncState>()(
  persist(
    (set) => ({
      syncCode: null,
      writeKey: null,
      statSyncPurchased: false,
      setSyncCode: (code) => set({ syncCode: code }),
      setWriteKey: (key) => set({ writeKey: key }),
      clearSync: () => set({ syncCode: null, writeKey: null }),
      setStatSyncPurchased: () => set({ statSyncPurchased: true }),
    }),
    {
      name: 'sync-storage',
      storage: secureStorageAdapter,
    }
  )
);
